import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Music, ExternalLink, Disc3 } from "lucide-react";
import axios from "axios";

const BACKEND_URL = "";
const API = `${BACKEND_URL}/api`;

const SelectaPage = () => {
  const [playlists, setPlaylists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlaylists = async () => {
      try {
        const response = await axios.get(`${API}/playlists`);
        setPlaylists(response.data.playlists || response.data);
      } catch (error) {
        console.error('Error fetching playlists:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPlaylists();
  }, []);

  return (
    <div className="min-h-screen py-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <span className="font-heading text-sm tracking-widest text-[#FFB347] mb-2 block">
            SÉLECTA
          </span>
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">
            Playlists & Albums
          </h1>
          <p className="text-[#A8A29E] text-lg max-w-2xl">
            Découvrez nos compilations et albums soigneusement sélectionnés.
          </p>
        </motion.div>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="card animate-pulse">
                <div className="aspect-square bg-[#1a1a1a]" />
                <div className="p-6 space-y-3">
                  <div className="h-6 bg-[#1a1a1a] rounded w-3/4" />
                  <div className="h-4 bg-[#1a1a1a] rounded w-1/2" />
                </div>
              </div>
            ))}
          </div>
        ) : playlists.length === 0 ? (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-center py-16">
            <Disc3 className="w-16 h-16 text-[#A8A29E] mx-auto mb-4" />
            <h3 className="font-display text-xl mb-2">Playlists à venir</h3>
            <p className="text-[#A8A29E]">Nos playlists seront bientôt disponibles</p>
          </motion.div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {playlists.map((playlist, index) => (
              <motion.a key={playlist.id} href={playlist.url} target="_blank" rel="noopener noreferrer" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }} className="card group cursor-pointer">
                <div className="aspect-square relative overflow-hidden">
                  <img src={playlist.cover || "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400"} alt={playlist.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0908] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-16 h-16 rounded-full bg-[#FFB347] flex items-center justify-center shadow-lg transform scale-75 group-hover:scale-100 transition-transform">
                      <ExternalLink className="w-8 h-8 text-[#0A0908]" />
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-xl font-bold mb-2 group-hover:text-[#FFB347] transition-colors">{playlist.title}</h3>
                  <div className="flex items-center gap-2 text-[#A8A29E]">
                    <Music className="w-4 h-4" />
                    <span className="text-sm">{playlist.track_count} morceaux</span>
                  </div>
                </div>
              </motion.a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectaPage;
